export const DASH_STYLE = {
  SOLID: 'Solid',
  DASH: 'Dash',
} as const

export type DashStyle = typeof DASH_STYLE[keyof typeof DASH_STYLE]

export const SMA_PERIOD = [5, 10, 20, 60, 120, 150, 180] as const

export type SmaPeriod = typeof SMA_PERIOD[number]
